import AdvisoryActivityLink from './component.jsx'
export default AdvisoryActivityLink
